<template>
  <MultipleAreaBase
    v-model="inputedValue"
    :width="width"
    :title="title"
    :pageData="pageData"
    :tables="pageData"
    :isFooter="isFooter"
    :isExpansionPanelFooter="true"
  >
    <template v-slot:[pageData[0].name]="{ item }">
      <slot :name="pageData[0].name" v-bind:item="item" />
    </template>
    <template v-slot:[pageData[1].name]="{ item }">
      <slot :name="pageData[1].name" v-bind:item="item" />
    </template>
    <template v-slot:[pageData[2].name]="{ item }">
      <slot :name="pageData[2].name" v-bind:item="item" />
    </template>
  </MultipleAreaBase>
</template>

<script>
import MultipleAreaBase from '@/components/layouts/Dialogs/MultipleArea/MultipleAreaBase'
import InputFormNew from '@/components/items/Designs/InputFormNew'
import NormalButton from '@/components/items/Buttons/NormalButton'
import { mapActions } from 'vuex'

export default {
  name: 'ShipDeliveryDialogBase',
  components: {
    MultipleAreaBase,
    InputFormNew,
    NormalButton
  },
  data: () => ({
    localPageInfoData: {},

    // Design
    inputFormStyle: {
      rowHeight: '40px',
      titleCols: 3,
      contentsCols: 12 - 3,
      inputItemHeight: '32px'
    },

    // pageData 0
    pageInfoDetail: {
      line1: [
        {
          name: 'incompleteOrderReason',
          text: 'ship.ship_incomplete-order-reason',
          required: true,
          component: 'SelectIncompleteOrderReason',
          cols: 3
        },
        {
          name: 'remarks',
          text: 'ship.ship_remarks-column',
          required: true,
          textPositionStart: true
        }
      ]
    }
  }),
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    isFooter: { default: false },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    },
    pageData: []
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    recItems: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        this.setInputData()
      }
    }
  },
  methods: {
    ...mapActions('Order', ['registerOrderIncomplete']),
    ...mapActions('Common', ['setIsLoading']),
    setInputData() {
      this.localPageInfoData = {
        line1: {
          incompleteOrderReason: { value: '', label: '' },
          remarks: ''
        }
      }
    },
    async sendOrderIncomplete() {
      this.setIsLoading(true)
      const params = {
        incompleteOrderReason:
          this.localPageInfoData.line1.incompleteOrderReason.value,
        remarks: this.localPageInfoData.line1.remarks
      }
      const isSucceed = await this.registerOrderIncomplete(params)
      if (isSucceed) {
        alert(this.$t('common.common_saved-alert'))
        this.$emit('complete')
      }
      this.setIsLoading(false)
    }
  }
}
</script>

<style scoped></style>
